import type { DeleteMeterResponse } from '@weft/api-definition';
import { DeleteMeterResponseSchema } from '@weft/api-definition';
import type { DeleteMeterRequest } from 'libs/client/src/generated';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useDeleteMeter(options?: UseMutationOptions<DeleteMeterResponse, unknown, DeleteMeterRequest>) {
  return useMutation({
    mutationFn: async ({ meterId }) => {
      const api = getPrivateApi();
      const deleteMeterResponse = await api.deleteMeter({ meterId });

      return DeleteMeterResponseSchema.parse(deleteMeterResponse);
    },
    ...options,
  });
}